import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import styles from "../../../ActiveLearningIssue.module.scss";
import hintImage17 from "../../../../../../assets/images/ActiveLearning/hint/img_17.webp";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          このWORKには、これまで考えてきた、『「問い」/「課題」/解決のアイデア/実現のステップ』とその過程が表示されている。
          <br />
          入力内容や中間発表でもらったコメントを振り返って、スライドやポスターなど、発表するための資料をつくろう。
        </p>
      </div>
      {question1 && (
        <div className={clsx(styles.question, styles.primary)}>
          <div className={styles.themEntry}>
            <p className={styles.title}>「問い」/その「問い」を立てた理由</p>
            <ul className={styles.pastAnswerList}>
              <li className={styles.pastAnswer}>回答データがありません。</li>
            </ul>
          </div>
          <div className={styles.themEntry}>
            <p className={styles.title}>「課題」/その「課題」を設定した理由</p>
            <ul className={styles.pastAnswerList}>
              <li className={styles.pastAnswer}>回答データがありません。</li>
            </ul>
          </div>
          <div className={styles.themEntry}>
            <p className={styles.title}>
              解決のアイデア/そのアイデアに決めた理由
            </p>
            <ul className={styles.pastAnswerList}>
              <li className={styles.pastAnswer}>回答データがありません。</li>
              <li className={styles.pastAnswer}>回答データがありません。</li>
              <li className={styles.pastAnswer}>回答データがありません。</li>
            </ul>
          </div>
          <div className={styles.themEntry}>
            <p className={styles.title}>
              解決のアイデアを実現するまでのステップ
            </p>
            <div className={clsx(styles.tree, styles.past)}>
              <p className={styles.answerList}>回答データがありません。</p>
            </div>
          </div>
          <div className={styles.themEntry}>
            <p className={styles.title}>{question1.title}</p>
            <p className={styles.read}>
              ヒントを参考に、補足したい内容があれば入力しよう。
            </p>
            <div className={styles.textAreaWrapper}>
              <TextArea />
            </div>
          </div>
        </div>
      )}
      <img src={hintImage17} alt="発表や資料づくりのヒント" />
    </div>
  );
};
export default Issue1Material;
